import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'appv2-footage-filter',
  templateUrl: './footage-filter.component.html',
  styleUrls: ['./footage-filter.component.scss']
})
export class FootageFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
